// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__mU8ij","spinner":"Loader_spinner__nwaaT","spin":"Loader_spin__krnne"};